import React from "react";
import PortalLayout from "../../enterprise/admin-shared/PortalLayout";
import PortalHeadSidebar from "./PortalHeadSidebar";
import PortalHeadHeader from "./PortalHeadHeader";

const PortalHeadShell = ({ children, hideSidebar = false, hideHeader = false, dashboardOnly = false }) => (
  <PortalLayout
    hideSidebar={hideSidebar}
    hideHeader={hideHeader}
    dashboardOnly={dashboardOnly}
    portalId="nyafaz_head"
    engagementSkin
    Sidebar={PortalHeadSidebar}
    Header={PortalHeadHeader}
  >
    {children}
  </PortalLayout>
);

export default PortalHeadShell;
